/* eslint-disable global-require */
module.exports = ['search.drawers.lotmobile.m8', 'catalogue.show.m1', 'catalogue.show.m2'];
